module.exports = __webpack_public_path__ + "img/cricket-icon-white.208d9944.png";